const SKIP_TYPES = new Set([
  'checkbox',
  'radio',
  'file',
  'hidden',
  'button',
  'submit',
  'reset',
  'color',
  'date',
  'datetime-local',
  'month',
  'week',
  'time',
  'password',
  'email',
  'search',
  'url',
  'range',
  'image',
]);

const NUMBER_OR_FRACTION = /^-?\d+([.,]\d+)?$|^\d+\s*\/\s*\d+$/;

export function isReplaceableNumericValue(value: string): boolean {
  return NUMBER_OR_FRACTION.test(value.trim());
}

export function shouldSelectNumericOnFocus(input: HTMLInputElement): boolean {
  if (input.readOnly || input.disabled || !input.value) return false;
  const type = (input.type || 'text').toLowerCase();
  if (SKIP_TYPES.has(type)) return false;
  const mode = (input.inputMode || '').toLowerCase();
  if (mode === 'decimal' || mode === 'numeric' || type === 'number') {
    return true;
  }
  return isReplaceableNumericValue(input.value);
}

function selectIfFocused(input: HTMLInputElement): void {
  if (document.activeElement !== input) return;
  input.select();
}

export function selectNumericInputValue(input: HTMLInputElement): void {
  if (!shouldSelectNumericOnFocus(input)) return;

  const apply = () => selectIfFocused(input);
  apply();
  requestAnimationFrame(apply);
  window.setTimeout(apply, 0);

  const onMouseUp = (event: MouseEvent) => {
    event.preventDefault();
    apply();
  };
  input.addEventListener('mouseup', onMouseUp, { once: true });
  input.addEventListener('click', apply, { once: true });
}

export function bindSelectNumericOnFocus(
  root: Document | HTMLElement = document
): () => void {
  const onFocusIn = (event: Event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    selectNumericInputValue(target);
  };
  root.addEventListener('focusin', onFocusIn);
  return () => root.removeEventListener('focusin', onFocusIn);
}
